import React, { useState } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Area, AreaChart } from 'recharts';
import { TrendData } from '../../utils/dashboardData';
interface SalesTrendProps {
  data: TrendData[];
}
const SalesTrend: React.FC<SalesTrendProps> = ({
  data
}) => {
  const [metric, setMetric] = useState<'value' | 'count'>('value');
  const formatYAxis = (tickItem: number) => {
    if (metric === 'value') {
      if (tickItem >= 1000) return `₨${(tickItem / 1000).toFixed(0)}k`;
      return `₨${tickItem}`;
    }
    return tickItem.toString();
  };
  const CustomTooltip = ({
    active,
    payload,
    label
  }: any) => {
    if (active && payload && payload.length) {
      return <div className="bg-white/90 backdrop-blur-md p-4 border border-slate-200 shadow-xl rounded-xl" data-id="element-236">
          <p className="font-semibold text-slate-900 mb-3" data-id="element-237">{label}</p>
          {payload.map((entry: any, index: number) => <div key={index} className="flex items-center justify-between space-x-6 mb-1.5" data-id="element-238">
              <div className="flex items-center space-x-2" data-id="element-239">
                <div className="w-2.5 h-2.5 rounded-full" style={{
              backgroundColor: entry.color
            }} data-id="element-240"></div>
                <span className="text-sm font-medium text-slate-600" data-id="element-241">
                  {entry.name}
                </span>
              </div>
              <span className="text-sm font-bold text-slate-900" data-id="element-242">
                {metric === 'value' ? `₨${entry.value.toLocaleString()}` : entry.value.toLocaleString()}
              </span>
            </div>)}
        </div>;
    }
    return null;
  };
  return <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-6 h-full flex flex-col" data-id="element-243">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between mb-8 gap-4" data-id="element-244">
        <div data-id="element-245">
          <h2 className="text-lg font-bold text-slate-900" data-id="element-246">Sales Trend</h2>
          <p className="text-sm text-slate-500 font-medium mt-1" data-id="element-247">
            Current vs Previous Period
          </p>
        </div>

        <div className="flex bg-slate-50 p-1 rounded-xl border border-slate-200/60 self-start sm:self-auto" data-id="element-248">
          <button onClick={() => setMetric('value')} className={`px-4 py-1.5 text-sm font-medium rounded-lg transition-all duration-200 ${metric === 'value' ? 'bg-white text-indigo-600 shadow-sm border border-slate-200/50' : 'text-slate-500 hover:text-slate-800'}`} data-id="element-249">
            Value
          </button>
          <button onClick={() => setMetric('count')} className={`px-4 py-1.5 text-sm font-medium rounded-lg transition-all duration-200 ${metric === 'count' ? 'bg-white text-indigo-600 shadow-sm border border-slate-200/50' : 'text-slate-500 hover:text-slate-800'}`} data-id="element-250">
            Count
          </button>
        </div>
      </div>

      <div className="flex-1 min-h-[250px] w-full" data-id="element-251">
        <ResponsiveContainer width="100%" height="100%" data-id="element-252">
          <AreaChart data={data} margin={{
          top: 5,
          right: 20,
          left: 0,
          bottom: 5
        }} data-id="element-253">
            <defs data-id="element-254">
              <linearGradient id="colorCurrent" x1="0" y1="0" x2="0" y2="1" data-id="element-255">
                <stop offset="5%" stopColor="#6366F1" stopOpacity={0.2} data-id="element-256" />
                <stop offset="95%" stopColor="#6366F1" stopOpacity={0} data-id="element-257" />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#F1F5F9" data-id="element-258" />
            <XAxis dataKey="time" axisLine={false} tickLine={false} tick={{
            fill: '#94A3B8',
            fontSize: 12,
            fontWeight: 500
          }} dy={10} data-id="element-259" />
            <YAxis axisLine={false} tickLine={false} tick={{
            fill: '#94A3B8',
            fontSize: 12,
            fontWeight: 500
          }} tickFormatter={formatYAxis} dx={-10} data-id="element-260" />
            <Tooltip content={<CustomTooltip data-id="element-262" />} cursor={{
            stroke: '#E2E8F0',
            strokeWidth: 2,
            strokeDasharray: '4 4'
          }} data-id="element-261" />
            <Legend verticalAlign="top" height={36} iconType="circle" wrapperStyle={{
            fontSize: '13px',
            fontWeight: 500,
            color: '#64748B'
          }} data-id="element-263" />
            <Area type="monotone" name="Current Period" dataKey={metric === 'value' ? 'currentValue' : 'currentCount'} stroke="#6366F1" strokeWidth={3} fillOpacity={1} fill="url(#colorCurrent)" activeDot={{
            r: 6,
            strokeWidth: 0,
            fill: '#6366F1'
          }} data-id="element-264" />
            <Line type="monotone" name="Previous Period" dataKey={metric === 'value' ? 'previousValue' : 'previousCount'} stroke="#CBD5E1" strokeWidth={2} strokeDasharray="5 5" dot={false} activeDot={{
            r: 4,
            fill: '#94A3B8',
            strokeWidth: 0
          }} data-id="element-265" />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>;
};
export default SalesTrend;